const ELLIPSIS = 3;
const CHARACTER_LIMIT = 30;
export const truncateFileName = (
  fileName: string,
  charLimit = CHARACTER_LIMIT
): string => {
  if (fileName.length <= charLimit) {
    return fileName;
  }
  const extensionIndex = fileName.lastIndexOf('.');
  const hasExtension = extensionIndex !== -1;
  const extension = hasExtension ? fileName.slice(extensionIndex) : '';

  const nameWithoutExtension = hasExtension
    ? fileName.slice(0, extensionIndex)
    : fileName;

  const maxChars = charLimit - ELLIPSIS;

  if (maxChars <= 0) {
    return fileName;
  }

  const halfChars = Math.floor(maxChars / 2);

  if (nameWithoutExtension.length <= maxChars) {
    return fileName;
  }
  const startPart = nameWithoutExtension.slice(0, halfChars);
  const endPart = nameWithoutExtension.slice(
    nameWithoutExtension.length - halfChars
  );

  return `${startPart}...${endPart}${extension}`;
};
